import { useState, useEffect } from 'react';
import '../wedding.css';

const WEDDING_DATE = new Date('2026-06-28T17:00:00-05:00');

const HOTELS = [
  {
    name: 'The Congress Plaza Hotel',
    distance: '0.2 mi',
    price: '$130 – $200',
    address: '520 S Michigan Ave, Chicago, IL 60605',
    description: 'Historic landmark hotel directly on Michigan Avenue, just a short stroll from the venue with sweeping lake views.',
    url: 'https://www.congressplazahotel.com/',
    featured: true,
  },
  {
    name: 'Hilton Chicago',
    distance: '0.3 mi',
    address: '720 S Michigan Ave, Chicago, IL 60605',
    price: '$180 – $300',
    description: 'Iconic full-service hotel on Michigan Avenue overlooking Grant Park and Lake Michigan.',
    url: 'https://www.hilton.com/en/hotels/chichhh-hilton-chicago/',
  },
  {
    name: 'Hotel Essex Chicago',
    distance: '0.3 mi',
    address: '800 S Michigan Ave, Chicago, IL 60605',
    price: '$150 – $250',
    description: "Stylish boutique hotel in a beautifully restored historic building, right next door to the venue.",
    url: 'https://www.hotelessex.com/',
  },
  {
    name: 'Blackstone, Autograph Collection',
    distance: '0.3 mi',
    address: '636 S Michigan Ave, Chicago, IL 60605',
    price: '$200 – $340',
    description: 'A Beaux-Arts landmark with timeless luxury, classic Chicago elegance, and an unbeatable Grant Park location.',
    url: 'https://www.marriott.com/hotels/travel/chibl-the-blackstone-autograph-collection/',
  },
  {
    name: 'Best Western Grant Park Hotel',
    distance: '0.4 mi',
    address: '1100 S Michigan Ave, Chicago, IL 60605',
    price: '$100 – $160',
    description: 'A comfortable, affordable option in the South Loop, close to the museum campus and lakefront trail.',
    url: 'https://www.bestwestern.com/en_US/book/hotel-rooms.14131.html',
  },
  {
    name: 'Palmer House Hilton',
    distance: '0.8 mi',
    address: '17 E Monroe St, Chicago, IL 60603',
    price: '$180 – $320',
    description: 'A legendary Chicago hotel in the heart of the Loop with an opulent lobby and world-class dining.',
    url: 'https://www.hilton.com/en/hotels/chiphhh-palmer-house-a-hilton-hotel/',
  },
];

function WeddingWebsite() {
  const [countdown, setCountdown] = useState(getCountdown());
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    document.title = 'Tim & Emilio — June 28, 2026';
    const timer = setInterval(() => setCountdown(getCountdown()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeSection]);

  function getCountdown() {
    const now = new Date();
    const diff = WEDDING_DATE - now;
    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, past: true };
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
      past: false,
    };
  }

  const sections = [
    { id: 'home', label: 'Home' },
    { id: 'details', label: 'Details' },
    { id: 'venue', label: 'Venue' },
    { id: 'hotels', label: 'Stay' },
  ];

  return (
    <div className="wedding-site">
      <nav className="wedding-nav">
        <div className="wedding-nav-inner">
          <span className="wedding-nav-monogram" onClick={() => setActiveSection('home')}>T &amp; E</span>
          <div className="wedding-nav-links">
            {sections.map((s) => (
              <button
                key={s.id}
                className={`wedding-nav-link${activeSection === s.id ? ' active' : ''}`}
                onClick={() => setActiveSection(s.id)}
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {activeSection === 'home' && (
        <section className="wedding-hero">
          <div className="wedding-hero-image">
            <img src="/wedding-hero.jpg" alt="Tim and Emilio" />
            <div className="wedding-hero-gradient" />
          </div>
          <div className="wedding-hero-content">
            <p className="wedding-pretext">Together with their families</p>
            <h1 className="wedding-names">
              <span>Tim</span>
              <span className="wedding-amp">&amp;</span>
              <span>Emilio</span>
            </h1>
            <div className="wedding-divider"><span /></div>
            <p className="wedding-invite-text">request the pleasure of your company at the celebration of their marriage</p>
            <p className="wedding-date-text">Sunday, the twenty-eighth of June, two thousand twenty-six</p>
            <p className="wedding-time-text">Five o'clock in the evening</p>
            <p className="wedding-venue-text">LM Studio · Chicago</p>

            {!countdown.past && (
              <div className="wedding-countdown">
                {[
                  { value: countdown.days, label: 'Days' },
                  { value: countdown.hours, label: 'Hours' },
                  { value: countdown.minutes, label: 'Minutes' },
                  { value: countdown.seconds, label: 'Seconds' },
                ].map((u) => (
                  <div key={u.label} className="countdown-unit">
                    <span className="countdown-number">{String(u.value).padStart(2, '0')}</span>
                    <span className="countdown-label">{u.label}</span>
                  </div>
                ))}
              </div>
            )}

            <button className="wedding-scroll-cue" onClick={() => setActiveSection('details')}>
              Discover the day ↓
            </button>
          </div>
        </section>
      )}

      {activeSection === 'details' && (
        <section className="wedding-section">
          <p className="wedding-eyebrow">The Celebration</p>
          <h2 className="wedding-section-title">An Evening Together</h2>
          <p className="wedding-section-subtitle">
            June 28, 2026 · 5:00 PM to 11:00 PM · LM Studio Chicago
          </p>

          <div className="wedding-timeline">
            <div className="wedding-timeline-item">
              <div className="wedding-timeline-time">5:00 PM</div>
              <div className="wedding-timeline-content">
                <div className="wedding-timeline-icon">&#x1F492;</div>
                <h3>Ceremony</h3>
                <p>Join us as we say "I do" in an intimate ceremony, surrounded by friends and family and the panoramic views of Grant Park and the Chicago skyline.</p>
              </div>
            </div>
            <div className="wedding-timeline-item">
              <div className="wedding-timeline-time">5:30 PM</div>
              <div className="wedding-timeline-content">
                <div className="wedding-timeline-icon">&#x1F37E;</div>
                <h3>Cocktails</h3>
                <p>Cocktail hour on the second floor.</p>
              </div>
            </div>
            <div className="wedding-timeline-item">
              <div className="wedding-timeline-time">6:30 PM</div>
              <div className="wedding-timeline-content">
                <div className="wedding-timeline-icon">&#x1F37D;</div>
                <h3>Dinner</h3>
                <p>A seated dinner in the stunning sixth-floor studio as the sun sets over the city.</p>
              </div>
            </div>
            <div className="wedding-timeline-item">
              <div className="wedding-timeline-time">8:00 PM</div>
              <div className="wedding-timeline-content">
                <div className="wedding-timeline-icon">&#x1F389;</div>
                <h3>Dancing</h3>
                <p>The floor is yours. Bring your best moves — we're celebrating until 11.</p>
              </div>
            </div>
            <div className="wedding-timeline-item wedding-timeline-finale">
              <div className="wedding-timeline-time">11:00 PM</div>
              <div className="wedding-timeline-content">
                <div className="wedding-timeline-icon">&#x2728;</div>
                <h3>Send-Off</h3>
                <p>One last toast and a Chicago goodbye.</p>
              </div>
            </div>
          </div>

          <div className="wedding-dresscode">
            <div className="wedding-dresscode-card">
              <div className="wedding-dresscode-icon">&#x1F455;</div>
              <p className="wedding-dresscode-label">Dress Code</p>
              <p className="wedding-dresscode-value">Cocktail Attire</p>
              <p className="wedding-dresscode-note">Summer attire, elegant — wear what makes you feel your best.</p>
            </div>
          </div>
        </section>
      )}

      {activeSection === 'venue' && (
        <section className="wedding-section">
          <p className="wedding-eyebrow">The Venue</p>
          <h2 className="wedding-section-title">LM Studio Chicago</h2>
          <p className="wedding-section-subtitle">808 S Michigan Ave · Chicago, IL 60605</p>

          <div className="wedding-venue-info">
            <div className="wedding-venue-details">
              <p className="wedding-venue-desc">
                Tucked along iconic Michigan Avenue, LM Studio is a contemporary event space that captures the
                spirit of Chicago. Two levels of light-filled rooms, floor-to-ceiling windows, and breathtaking
                views of Grant Park, the lakefront, and the skyline.
              </p>
              <p className="wedding-venue-desc">
                The South Loop puts you steps from the Art Institute, Millennium Park, and the Museum Campus —
                a perfect home base whether you're flying in or making a weekend of it.
              </p>
              <div className="wedding-venue-features">
                <div className="wedding-venue-feature"><span>✦</span> Floor-to-ceiling windows with panoramic city views</div>
                <div className="wedding-venue-feature"><span>✦</span> Two stunning levels — Atrium and Studio</div>
                <div className="wedding-venue-feature"><span>✦</span> Custom-built bars on both floors</div>
                <div className="wedding-venue-feature"><span>✦</span> Heart of Chicago — steps from Grant Park</div>
              </div>
              <a href="https://www.lmstudiochicago.com/" target="_blank" rel="noopener noreferrer" className="wedding-venue-link">
                Visit LM Studio →
              </a>
            </div>
            <div className="wedding-venue-map">
              <iframe
                title="LM Studio Chicago"
                src="https://maps.google.com/maps?q=808+S+Michigan+Ave,+Chicago,+IL+60605&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="400"
                style={{ border: 0, borderRadius: 16 }}
                allowFullScreen=""
                loading="lazy"
              />
            </div>
          </div>

          <div className="wedding-parking">
            <h3>Getting There</h3>
            <div className="wedding-transport-grid">
              <div className="wedding-transport-card">
                <div className="wedding-transport-icon">&#x1F697;</div>
                <strong>Parking</strong>
                <p>Several garages along Michigan and Wabash. Valet details to come.</p>
              </div>
              <div className="wedding-transport-card">
                <div className="wedding-transport-icon">&#x1F687;</div>
                <strong>Public Transit</strong>
                <p>CTA Red, Orange, or Green to Roosevelt — a five-minute walk. The #3 and #4 buses stop right on Michigan.</p>
              </div>
              <div className="wedding-transport-card">
                <div className="wedding-transport-icon">&#x1F695;</div>
                <strong>Rideshare</strong>
                <p>Uber and Lyft drop-off at 808 S Michigan Ave.</p>
              </div>
            </div>
          </div>
        </section>
      )}

      {activeSection === 'hotels' && (
        <section className="wedding-section">
          <p className="wedding-eyebrow">Where to Stay</p>
          <h2 className="wedding-section-title">Make a Weekend of It</h2>
          <p className="wedding-section-subtitle">
            Hand-picked hotels within easy walking distance of LM Studio.
          </p>
          <div className="wedding-hotels-grid">
            {HOTELS.map((hotel) => (
              <div key={hotel.name} className={`wedding-hotel-card${hotel.featured ? ' wedding-hotel-featured' : ''}`}>
                {hotel.featured && <div className="wedding-hotel-badge">Closest to Venue</div>}
                <div className="wedding-hotel-header">
                  <h3>{hotel.name}</h3>
                  <span className="wedding-hotel-distance">{hotel.distance}</span>
                </div>
                <p className="wedding-hotel-address">{hotel.address}</p>
                <p className="wedding-hotel-desc">{hotel.description}</p>
                <div className="wedding-hotel-footer">
                  <span className="wedding-hotel-price">{hotel.price}<span className="wedding-hotel-price-unit"> / night</span></span>
                  <a href={hotel.url} target="_blank" rel="noopener noreferrer" className="wedding-hotel-book">
                    Book →
                  </a>
                </div>
              </div>
            ))}
          </div>
          <p className="wedding-hotels-note">
            Rates are estimates and may vary by date. Booking early is recommended — Chicago summers fill up fast.
          </p>
        </section>
      )}

      <footer className="wedding-footer">
        <div className="wedding-footer-monogram">T &amp; E</div>
        <p>June 28, 2026 · Chicago, Illinois</p>
        <p className="wedding-footer-sub">We can't wait to celebrate with you.</p>
      </footer>
    </div>
  );
}

export default WeddingWebsite;
